import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IDepartListInfo, IDepartListParam } from './interface';

export const getDepartmentList = (data: IDepartListParam) => {
    if (!data.type) {
        delete data.type;
    }
    return fetchData(Api.GET_DEPARTMENT_LIST, data).then((res: IResponse<IDepartListInfo>) => {
        return res.data;
    });
};
